import { Injectable } from '@angular/core';
import { CuadriculaFormModel, CuadriculaFromApi, CuadriculaListModel } from './models/cuadricula.model';
import { SsoService } from '../sso/sso.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuditoriaService } from '../auditoria/auditoria.service';
import { AuditoriaModel } from '../auditoria/models/auditoria.model';
import { MainComponent } from 'src/app/components/main/main.component';
import { Accion } from '../auditoria/models/accion.model';
import { firstValueFrom } from 'rxjs';
import { map, Observable, tap } from 'rxjs';
import { MapBounds, MapLatLng } from 'movisat-maps';
import { ZonaModel } from '../zones/models/zona.model';

@Injectable({
  providedIn: 'root'
})
export class CuadriculaService {
  private usuario = this.ssoService.getTicket().Usuario.Email;
  private auditoria: AuditoriaModel = new AuditoriaModel(this.usuario, 0);

  public constructor(private ssoService: SsoService, private http: HttpClient, private auditoriaService: AuditoriaService) { }

  // Obtener Cuadriculas
  public getCuadriculas(zonas: ZonaModel[]): Observable<CuadriculaListModel[]> {
    return this.http.get<CuadriculaFromApi[]>(
      this.ssoService.getTicket().UrlApi + '/api/cuadriculas?enterprise=' + this.ssoService.getTicket().Empresa.IdGestion
    ).pipe(
      map( resp => {
        const cuadriculas: CuadriculaListModel[] = resp.map(cuadricula => ({
          id: cuadricula.id,
          nombre: cuadricula.nombre,
          empresa: cuadricula.empresa,
          lado: cuadricula.lado,
          zona: zonas.find(z => z.Id === cuadricula.idZona)?.Nombre || '',
          idZona: cuadricula.idZona,
          descripcion: cuadricula.descripcion,
          numeracionVisible: cuadricula.numeracionVisible ? MainComponent.translate('SI') : MainComponent.translate('NO'),
          marco: this.__calcMarco(cuadricula)
        }))
        return cuadriculas;
      }),
    );
  }

  // Añadir Cuadricula
  public async addCuadricula(cuadricula: CuadriculaFormModel, zonas: ZonaModel[]): Promise<CuadriculaListModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    cuadricula.empresa = this.ssoService.getTicket().Empresa.IdGestion
    delete cuadricula.marco;

    return firstValueFrom(this.http.post<CuadriculaFromApi>(this.ssoService.getTicket().UrlApi + '/api/cuadricula', JSON.stringify(cuadricula), httpOptions)
      .pipe(
        tap(
          (resp) => {
            if (cuadricula.id) {
              this.auditoria.AccionId = Accion.EDITAR_CUADRICULA;
            } else {
              this.auditoria.AccionId = Accion.CREAR_CUADRICULA;
            }
            this.msgChangeResponse(resp);
            this.auditoriaService.addAuditoria(this.auditoria);
          }
        ),
        map(
          (resp) => {
            return {
              'id': resp.id,
              'nombre': resp.nombre,
              'empresa': resp.empresa,
              'lado': resp.lado,
              'zona': zonas.find(z => z.Id === resp.idZona)?.Nombre || '',
              'idZona': resp.idZona,
              'descripcion': resp.descripcion,
              'numeracionVisible': resp.numeracionVisible ? MainComponent.translate('SI') : MainComponent.translate('NO'),
              'marco': this.__calcMarco(resp)
            }
          }
        )
      )
    );
  }

  // Borrar Cuadricula
  async delCuadricula(id: number) {
    let result = null;
    try {
      result = await this.http.delete(this.ssoService.getTicket().UrlApi + '/api/cuadricula?id=' + id + '&enterprise=' + this.ssoService.getTicket().Empresa.IdGestion).toPromise();

      this.auditoria.AccionId = Accion.ELIMINAR_CUADRICULA;
      this.auditoria.Info = 'ID cuadricula: ' + id;
      this.auditoriaService.addAuditoria(this.auditoria);
    } catch (e) {
      console.log(e);
    }
    return result;
  }

  async saveConfigLado(lado: number) {
    let result = null;
    try {
      result = await this.http.post(this.ssoService.getTicket().UrlApi + '/api/configuracion/cuadricula/lado?lado=' + lado + '&empresa=' + this.ssoService.getTicket().Empresa.IdGestion, null).toPromise();
    } catch (e) {
      console.error(e);
    }
    return result;
  }

  async getConfigLado(): Promise<any> {
    let result = 500;
    try {
      const response = await firstValueFrom(
        this.http.get<any>(
          `${this.ssoService.getTicket().UrlApi}/api/configuracion/cuadricula/lado?enterprise=${this.ssoService.getTicket().Empresa.IdGestion}`
        )
      );
      result = Number.parseInt(response.value);
    } catch (error) {
    }

    return result;
  }

  msgChangeResponse(response: any): string {
    return this.auditoria.Info = 'ID: ' + response.id + ', ' + MainComponent.getInstance().translate('Nombre') + ': ' + response.nombre;
  }

  private __calcMarco(cuadricula: CuadriculaFromApi): MapBounds {
    if(!cuadricula.marco) {
      return null;
    }

    const swCorner = new MapLatLng(90, 180);
    const neCorner = new MapLatLng(-90, -180);

    cuadricula.marco?.coordinates[0].forEach(v => {
      if (v[0] > neCorner.lng) {
        neCorner.lng = v[0];
      }
      if (v[1] > neCorner.lat) {
        neCorner.lat = v[1];
      }

      if (v[0] < swCorner.lng) {
        swCorner.lng = v[0];
      }
      if (v[1] < swCorner.lat) {
        swCorner.lat = v[1];
      }
    });

    return new MapBounds(swCorner, neCorner);
  }
}
